import React from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useTranslation } from '@refinedev/core';
import useAPI from '@/api/useApi';
import { endPoints } from '@/api/configs';

interface EditAdminModalProps {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
  adminId: string;
  initialValues: { name: string };
}

export const EditAdminModal: React.FC<EditAdminModalProps> = ({
  open,
  onClose,
  refetch,
  adminId,
  initialValues,
}) => {
  const { translate } = useTranslation();
  const [form] = Form.useForm<{ name: string }>();
  const { usePatch } = useAPI();
  const { mutate: updateAdmin, isLoading } = usePatch(endPoints.admin(adminId));

  const handleOk = async () => {
    const validatedValues = await form.validateFields();
    updateAdmin(
      { name: validatedValues.name },
      {
        onSuccess: () => {
          message.success(translate('admin-edit.success'));
          refetch();
          onClose();
        },
        onError: (error) => {
          message.error(error.message);
        },
      }
    );
  };

  return (
    <Modal
      title={translate('edit-admin.title')}
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okText={translate('buttons.save')}
      cancelText={translate('buttons.cancel')}
      okButtonProps={{ loading: isLoading }}
    >
      <Form form={form} layout="vertical" initialValues={initialValues}>
        <Form.Item
          name="name"
          label={translate('listing-admins.name')}
          rules={[
            {
              required: true,
              message: translate('pages.errors.required'),
            },
          ]}
        >
          <Input placeholder={translate('listing-admins.name.placeholder')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
